import {
  BsInstagram,
  BsTwitter,
  BsYoutube,
  // BsFacebook,
  BsLinkedin,
} from "react-icons/bs";

const Instagram = ({ size }) => {
  return (
    <a
      href="https://www.instagram.com/drishti_rcbpit/?hl=en"
      target="_blank"
      rel="noreferrer"
    >
      <BsInstagram
        fontSize={size}
        className="cursor-pointer hover:scale-125 transform ease-out hover:text-mix-400"
      />
    </a>
  );
};

const Youtube = ({ size }) => {
  return (
    <a
      href="https://www.youtube.com/channel/UCuXuzbLIi2LcbHPMeU8kj7w"
      target="_blank"
      rel="noreferrer"
    >
      <BsYoutube
        fontSize={size}
        className="cursor-pointer hover:scale-125 transform ease-out hover:text-mix-400"
      />
    </a>
  );
};

const Twitter = ({ size }) => {
  return (
    <a href="https://twitter.com/OfBpit?s=20" target="_blank" rel="noreferrer">
      <BsTwitter
        fontSize={size}
        className="cursor-pointer hover:scale-125 transform ease-out hover:text-mix-400"
      />
    </a>
  );
};

const Linkedin = ({ size }) => {
  return (
    <a
      href="https://www.linkedin.com/in/rcbpit?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3B0eI9bgbRQlabDhCXzy0o6A%3D%3D"
      target="_blank"
      rel="noreferrer"
    >
      <BsLinkedin
        fontSize={size}
        className="cursor-pointer hover:scale-125 transform ease-out hover:text-mix-400"
      />
    </a>
  );
};

export { Instagram, Youtube, Twitter, Linkedin };
